/* eslint-disable jsx-a11y/iframe-has-title */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Player, BigPlayButton } from "video-react";

import "./VideoPlay.css";

const VideoPlay = forwardRef(({ src, width, height }: any, ref) => {
  const [actWidth, setActWidth] = useState<any>(width);
  const [actHeight, setActHeight] = useState<any>(height);

  useImperativeHandle(ref, () => ({
    onScale: () => {
      setActWidth(height);
      setActHeight(actWidth);
    },
    noScale: () => {
      setActWidth(width);
      setActHeight(height);
    },
  }));
  return (
    <iframe
      style={{ height: `${actHeight}px`, width: `${actWidth}px` }}
      id="myIframe"
      src={src}
      scrolling="no"
      frameBorder="no"
      allowFullScreen={true}
    ></iframe>

    // @ts-ignore
    // <Player src={src} fluid>
    //   <BigPlayButton position="center" />
    // </Player>
  );
});
export default VideoPlay;
